import { Currency } from '@uniswap/sdk-core'
import { ChainId, NATIVE_CURRENCY } from 'constants/chains'

export function currencyId(currency: Currency): string {
  if (currency.isNative) return NATIVE_CURRENCY[currency.chainId as ChainId].symbol
  if (currency.isToken) return currency.address
  throw new Error('invalid currency')
}
